import { Component, Input, ViewChild } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { BallotDocumentService } from '../../services/ballot-document.service';
import { IVoteDocument } from '../../models/vote-document';
import { MatDialog } from '@angular/material/dialog';
import { materialSymbols } from '../../../../../shared/constants/material-symbols';
import { IApiResponse } from '../../../../../shared/models/api-response';
import { IFilePreview } from '../../../../../shared/models/file-preview';
import { ToastService } from '../../../../../shared/services/toast.service';
import { FileDownloadUtility } from '../../../../../shared/utilities/blob-download-utility';
import { FilePreviewComponent } from '../../../../controls/file-preview/file-preview';

@Component({
    selector: 'app-votes-documents-popover',
    templateUrl: './votes-documents-popover.component.html',
    styleUrl: './votes-documents-popover.component.scss',
    standalone: false
})
export class VotesDocumentsPopoverComponent {
  @ViewChild('viewVotePopover') viewVotePopover!: NgbPopover;
  @Input() id: string = 'view-vote-popover';
  @Input() popoverTitle: string = '';
  @Input() ballotType!: string ;
  @Input() ballotId: string = '';
  @Input() voteId: string = '';

  subscriptions: Subscription = new Subscription();

  closeSymbol: string = materialSymbols.close;

  constructor(private _BallotService: BallotDocumentService,
              private _toastService: ToastService,
              public dialog: MatDialog){

              }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public openPopover() : void {
    this.viewVotePopover.open();
  }

  downloadAuthDocument() {
    this.subscriptions.add(this._BallotService.DownloadAuthDoc(this.ballotType, this.voteId, this.ballotId).subscribe({
          next: (response: IApiResponse<IVoteDocument>) => {
             const blobFile = response?.content;
             FileDownloadUtility.downloadbase64StringToBrowser(blobFile.fileContent??blobFile?.blobContent, blobFile.fileName??blobFile?.overview.metadata.filename);
             this.viewVotePopover.close();
          },
          error: (error) => {
            this._toastService.showError("Download failed for this document.", "Download Failed");
          }
        }));
  }

  previewAuthDocument() {
    this.subscriptions.add(this._BallotService.DownloadAuthDoc(this.ballotType, this.voteId, this.ballotId).subscribe({
        next: (response: IApiResponse<IVoteDocument>) => {
          let filePreview: IFilePreview;
          const blobFile = response?.content;

          filePreview = {
            fileName: blobFile.fileName??blobFile?.overview.metadata.filename,
            fileContent: blobFile.fileContent??blobFile?.blobContent as any,
            outlookMessage: blobFile.outlookMessageDetails
          }
          this.viewVotePopover.close();
          this.dialog.open(FilePreviewComponent, {
            maxWidth: '75vw',
            maxHeight: '80vh',
            height: '100%',
            width: '100%',
            data: filePreview,
          });

        },
        error: (error) => {
          this._toastService.showError("Download failed for this document.", "Download Failed");
        }
    }));
  }
}
